import moment from "moment";
import { ValueOrDots } from "../../../components/exportWord/partials";

const TemplateGiayBaoLamThemGio = (props: any) => {
  const { data } = props;

  const totalHours = data?.dataSelect?.listCongViec.reduce((sum: number, row: any) => sum + row.tongSoGio, 0);

  return (
    <div className="word spaces px-70 colors-word">
      <div className="spaces text-center flex flex-between">
        <div>
          <p className="fw-600">Đơn vị:
            <span className="spaces text-uppercase ml-5">
              <ValueOrDots className="" value={data?.dataDangKy?.donViCongTac?.name || ""} size={70} />
            </span>
          </p>
          <p className="fw-600">
            Khoa, phòng:
            <span className="spaces text-uppercase ml-5">
              <ValueOrDots className="" value={data?.dataDangKy?.phongBan?.name || ""} size={70} />
            </span>
          </p>
        </div>
        <div className="">
          <p className="spaces fw-600 p-0">Mẫu số: 01b-LĐTL</p>
          <p className="spaces p-0">
            (Ban hành kèm theo Thông tư số 133/2016/TT-BTC
          </p>
          <p className="spaces p-0">
            ngày 26/08/2016 của Bộ Tài chính)
          </p>

        </div>
      </div>
      <div className="text-center">
        <p className="text-uppercase fw-600 fs-lg">Giấy báo làm thêm giờ</p>
        <p className="">
          Ngày <ValueOrDots size={6} value={data?.dataDangKy?.ngayNop ? moment(data?.dataDangKy?.ngayNop).format("DD") : ""} /> tháng <ValueOrDots size={6} value={data?.dataDangKy?.ngayNop ? moment(data?.dataDangKy?.ngayNop).format("MM") : ""} /> năm <ValueOrDots size={10} value={data?.dataDangKy?.ngayNop ? moment(data?.dataDangKy?.ngayNop).format("YYYY") : ""} />
        </p>
      </div>
      <div className="flex flex-end">
        <p>
          Số: <ValueOrDots value={""} size={10} />
        </p>
      </div>
      <div className="spaces ml-80">
        <p>
          - Họ tên: <ValueOrDots className="text-uppercase" value={data?.dataSelect?.employeeText || ""} size={30} />
        </p>
        <p>
          - Nơi công tác: <ValueOrDots className="text-uppercase" value={data?.dataDangKy?.phongBan?.name || ""} size={30} />
        </p>
      </div>

      <div className="spaces mt-16">
        <table className="table-auto border border-collapse border-gray-600 w-100 text-center">
          <thead>
            <tr>
              <th className="border border-gray-600" rowSpan={2}>Ngày tháng</th>
              <th className="border border-gray-600" rowSpan={2}>Những công việc đã làm</th>
              <th className="border border-gray-600" colSpan={3}>Thời gian làm thêm</th>
              <th className="border border-gray-600" rowSpan={2}>Thành tiền</th>
              <th className="border border-gray-600" rowSpan={2}>Ghi chú</th>
            </tr>
            <tr>
              <th className="border border-gray-600">Từ giờ</th>
              <th className="border border-gray-600">Đến giờ</th>
              <th className="border border-gray-600">Tổng số giờ</th>
            </tr>
          </thead>
          <tbody>
            {data?.dataSelect?.listCongViec.map((congViec: any, index: number) => (
              <tr key={`congViec-${index}`}>
                <td className="border border-gray-600">{congViec?.ngayDkTruc ? moment(congViec?.ngayDkTruc).format("DD/MM") : ""}</td>
                <td className="border border-gray-600">{congViec?.congViec}</td>
                <td className="border border-gray-600">{congViec?.thoiGianBatDau}</td>
                <td className="border border-gray-600">{congViec?.thoiGianKetThuc}</td>
                <td className="border border-gray-600">{congViec?.tongSoGio}</td>
                <td className="border border-gray-600"></td>
                <td className="border border-gray-600"></td>
              </tr>
            ))}
            {[...Array(17)].map((_, i) => (
              <tr key={i}>
                <td className="border border-gray-600">&nbsp;</td>
                <td className="border border-gray-600">&nbsp;</td>
                <td className="border border-gray-600">&nbsp;</td>
                <td className="border border-gray-600">&nbsp;</td>
                <td className="border border-gray-600">&nbsp;</td>
                <td className="border border-gray-600">&nbsp;</td>
                <td className="border border-gray-600">&nbsp;</td>
              </tr>
            ))}
            <tr>
              <td className="border border-gray-600">&nbsp;</td>
              <td className="border border-gray-600 text-left spaces pl-10" colSpan={3}>Tổng số</td>
              <td className="border border-gray-600 fw-600">{totalHours}</td>
              <td className="border border-gray-600">&nbsp;</td>
              <td className="border border-gray-600">&nbsp;</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="footer flex flex-between spaces mt-16 align-start mb-100">
        <div className="text-center">
          <p className="title-footer spaces fw-600 m-0">Người báo làm thêm giờ</p>
          <p className="span-footer font-italic spaces m-0">(Ký, Họ tên)</p>
        </div>
        <div className="text-center spaces max-w-300">
          <p className="title-footer spaces fw-600 m-0">Xác nhận của bộ phận, phòng ban có người làm thêm</p>
          <p className="span-footer font-italic spaces m-0">(Ký, Họ tên)</p>
        </div>
        <div className="text-center">
          <p className="title-footer spaces fw-600 m-0">Người duyệt</p>
          <p className="span-footer font-italic spaces m-0">(Ký, Họ tên)</p>
        </div>
      </div>
    </div>
  );
}

export default TemplateGiayBaoLamThemGio;